export default {
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
};
